<template>
<span>
    <span style="display: none"
          data-location
          :data-latitude="latitude"
          :data-id="id"
          :data-longitude="longitude">
        <slot></slot>
    </span>
</span>
</template>

<script>

export default {
    props: {
        latitude: {
            type: String,
            _descr: 'latitude of location',
            required: true,
        },
        longitude: {
            type: String,
            _descr: 'longitude of location',
            required: true,
        },
        id: {
            type: String,
            _descr: 'id of location',
            required: true,
        },
    },
}
</script>
